import React from 'react'
import { getBookMarks } from "../../common/helpers/bookmark";
import { AppDataReducer } from "../reducers/AppDataReducer";

export const AppDataContext = React.createContext();
export default function AppDataContextProvider(props) {
  //app holds the values from from admin panel
  //like ep_format etc
  let initialState = {
		app: {},
		isLoaded: { value: false, time: 0 },
		genre: [],
		animeList: [],
		search: {
			//status => loading ,error, success , ideal , notfound
			//ideal is for the default state ...
			status: "ideal",
			results: [],
		},
		latestAnime: [],
		recentlyAdded: [],
		studioList: [],
		trendingNow: [],
		animeDetails: {},
		movies: [],

		news: [],
		status: ["Finished", "On Going", "Coming Soon", "Cancelled"],
		recommendationAnime: [],
		bookmark: getBookMarks() || [],
	};
  const [appData, dispatch] = React.useReducer(AppDataReducer, initialState);
  return (
    <AppDataContext.Provider value={{ appData, dispatch }}>
      {props.children}
    </AppDataContext.Provider>
  );
}
